/**
 * Guía: Flujo de puntos.
 *
 * Contenido derivado del capítulo **34c** del manual (Flujo de puntos) y de
 * BACKEND-121PASS/docs/POINTS_GRANTS.md: otorgar a mano con vista previa, el
 * tope por país y las campañas automáticas.
 *
 * El primer paso es el aviso: lo que se regala no se puede retirar. Un punto
 * vale una unidad de la moneda del país y lo paga 121Pass cuando se gasta.
 */

import type { TourFlow } from '../types';

// Regalos › Puntos 121 (antes /points-flow). `href` es el tipo y cada paso
// lleva la ruta de su pestaña.
const FLUJO_PATH = '/gifts/puntos';
const RESUMEN_PATH = '/gifts/puntos/resumen';
const OTORGAR_PATH = '/gifts/puntos/otorgar';
const CAMPANAS_PATH = '/gifts/puntos/campanas';

export const c34cFlujoDePuntos: TourFlow = {
  id: 'admin.points-flow',
  chapter: '34c',
  title: 'Flujo de puntos',
  summary:
    'Regalar Puntos 121 a mano o con campañas automáticas, y el tope que exige paso de seguridad.',
  href: FLUJO_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Lo que se regala no se recupera',
      body:
        'Un punto vale una unidad de la moneda del país y 121Pass lo paga cuando el ' +
        'cliente lo gasta en cualquier comercio. Otorgar no se deshace: por eso siempre ' +
        'hay vista previa y queda el motivo en la auditoría.',
      route: OTORGAR_PATH,
    },
    {
      id: 'kpis',
      title: 'Cuánto se ha regalado y cuánto se gastó',
      body:
        'El Resumen dice cuánto se regaló, cuánto queda en billeteras, cuánto venció y ' +
        'cuánto ya se redimió, con los movimientos de cada cliente.',
      target: 'admin.promoCredits.kpis',
      route: RESUMEN_PATH,
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'recipients',
      title: 'Uno a uno o una lista',
      body:
        'Busca clientes por nombre, correo o teléfono, o pega o sube una lista. Los ' +
        'teléfonos sin indicativo se toman del país.',
      target: 'admin.pointsFlow.recipients',
      route: OTORGAR_PATH,
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'preview',
      title: 'Primero la vista previa',
      body:
        'Antes de otorgar ves a quién se encontró, a quién no y el total. Si supera el ' +
        'tope del país, solo un super administrador puede confirmar, con el código del ' +
        'correo y el del autenticador.',
      target: 'admin.pointsFlow.preview',
      route: OTORGAR_PATH,
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'campaigns',
      title: 'Campañas que se otorgan solas',
      body:
        'Registro nuevo, primera compra, reactivación y cumpleaños. Se crean en borrador ' +
        'y otorgan al activarlas; solo puede haber una activa por disparador. Sin cupo, ' +
        'activarla exige paso de seguridad.',
      target: 'admin.campaigns.statusTabs',
      route: CAMPANAS_PATH,
      placement: 'bottom',
      optionalTarget: true,
    },
  ],
};
